import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from "@angular/router";
import {NgSelectModule} from '@ng-select/ng-select';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BrowserModule} from "@angular/platform-browser";
import {CarouselModule, ModalModule, TabsModule, TooltipModule} from "ngx-bootstrap";
import {HousingRequestComponent} from "./housing-request.component";
import {ReportModule} from "../admin/report/report.module";
import {BaseModule} from "../../base/base.module";
import {SharedModule} from "../../shared/shared/shared.module";
import { HousingRequestFilterCheckComponent } from './housing-request-filter-check/housing-request-filter-check.component';
import { HousingRequestFilterTranslationService } from '../../services/housing-request-filter/housing-request-filter-translation.service';

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ReportModule,
    CarouselModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    BaseModule,
    SharedModule,
  ],
  declarations: [
    HousingRequestComponent,
    HousingRequestFilterCheckComponent,
  ],
  providers: [HousingRequestFilterTranslationService],
  exports: []
})
export class HousingRequestModule {
}
